import {createContext} from 'react';

const ProfileContextMobile = createContext(null);

export default ProfileContextMobile;
